import { render, staticRenderFns } from "./ManufacturingOrders.vue?vue&type=template&id=2ffcc67b&"
import script from "./ManufacturingOrders.vue?vue&type=script&lang=js&"
export * from "./ManufacturingOrders.vue?vue&type=script&lang=js&"
import style0 from "./ManufacturingOrders.vue?vue&type=style&index=0&id=2ffcc67b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports